import { createSlice } from "@reduxjs/toolkit";
import {
  getFuleDropdownValue,
  getManufacturerDropdownValue,
  getModalALLDropdownValue,
  getModalDropdownValue,
  getVehicle,
  getVehicleById,
  getDocumentById,
  singleVisibiliteInfo,
} from "../services/AddVehicle";
import { formatDate } from "../components/Common/FormatDate";

const vehicleSlice = createSlice({
  name: "vehicleSlice",
  initialState: {
    manufacturersDropdown: [],
    modalDropdown: [],
    fuleDropdown: [],
    vehicleList: [],
    vehicleAllData: [],
    vehicleSearchList: [],
    singlevehicleData: {},
    singlevehicleDocument: {},
    currentFleetPage: 0,
    loading: false,
    searchText: {
      search: "",
      company: "",
      status: "",
      owner: "",
      vehicle_location: "",
      available_for: "",
      available_starting: "",
    },
    singleParamsData: null,
  },

  reducers: {
    changeSearchText: (state, action) => {
      state.searchText = action.payload;
    },

    loader(state, action) {
      state.loading = action.payload;
    },

    getVehicleList: (state, action) => {
      const updatedVehicleList = action.payload.map((vehicle) => ({
        ...vehicle,
        updated_date: formatDate(vehicle.updated_date),
      }));
      state.vehicleList = updatedVehicleList;
      state.vehicleAllData = updatedVehicleList;
      state.vehicleSearchList = updatedVehicleList;
      state.loading = false;
    },

    getSingleVehicleData: (state, action) => {
      const { msg, ...dataWithoutMsg } = action.payload;
      state.singlevehicleData = dataWithoutMsg;
      state.loading = false;
    },

    getSingleVisibiliteData: (state, action) => {
      state.singleVisibiliteData = action.payload;
    },

    getSingleVehicleDocument: (state, action) => {
      state.singlevehicleDocument = action.payload;
    },

    getManufacturerDropdown: (state, action) => {
      const manufacturerData = action.payload;
      const sortedManufacturerData = manufacturerData?.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      state.manufacturersDropdown = sortedManufacturerData;
    },

    getModalDropdown: (state, action) => {
      const modalData = action.payload;
      const sortModalData = modalData?.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      state.modalDropdown = sortModalData;
    },

    getModalALLValues: (state, action) => {
      const modalData = action.payload;
      const sortModalData = modalData?.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      state.modalDropdown = sortModalData;
    },

    getFuleDropdown: (state, action) => {
      state.fuleDropdown = action.payload;
    },

    setFleetCurrentPage: (state, action) => {
      state.currentFleetPage = action.payload;
    },

    searchVehicleData: (state, action) => {
      const {
        search,
        company,
        status,
        owner,
        vehicle_location,
        active,
        motorisation,
        available_for,
        available_starting,
      } = action.payload;

      const searchTerm = search?.toLowerCase();
      // const { name } = company;

      const filtered = state.vehicleAllData?.filter((item) => {
        const manufacturerMatch = `${item.manufacturer} ${item.model} ${
          item.declination ? item.declination.join(" ") : ""
        } ${item?.license_plate}`
          ?.toLowerCase()
          ?.includes(searchTerm);
        const companyMatch = company
          ? company
              .map((r) => r.toLowerCase())
              .includes(item.manufacturer?.toLowerCase())
          : item;
        const statusMatch = status
          ? item.status?.toLowerCase() === status?.toLowerCase()
          : item;
        const ownerMatch = owner
          ? item.owner?.toLowerCase().includes(owner?.toLowerCase())
          : item;
        const locationMatch = vehicle_location
          ? item.vehicle_location?.toString().includes(vehicle_location)
          : true;
        const activeMatch = active
          ? item.active?.toLowerCase()?.includes(active?.toLowerCase())
          : item;
        const motorisationMatch = motorisation
          ? item?.main_fuel?.name
              ?.toLowerCase()
              ?.includes(motorisation?.toLowerCase())
          : item;
        let dateMatch = true; // Default to true if no availability filter is applied
        {
          const monthsToAdd = available_for ? parseInt(available_for, 10) : 0;
          const hasStart = Boolean(available_starting);
          if (monthsToAdd > 0 || hasStart) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const filterStartDate = hasStart
              ? new Date(available_starting)
              : today;
            filterStartDate.setHours(0, 0, 0, 0);

            const months = monthsToAdd > 0 ? monthsToAdd : 1; // default 1 month if only start provided
            const filterEndDate = new Date(filterStartDate);
            filterEndDate.setMonth(filterEndDate.getMonth() + months);
            filterEndDate.setHours(23, 59, 59, 999);

            const resStart = item.reservation_info?.date_reser_start
              ? new Date(item.reservation_info.date_reser_start)
              : null;
            const resEnd = item.reservation_info?.date_reser_end
              ? new Date(item.reservation_info.date_reser_end)
              : null;

            // If no reservation info, consider available
            if (!resStart && !resEnd) {
              dateMatch = true;
            } else {
              // Determine overlap between [filterStartDate, filterEndDate] and [resStart, resEnd]
              let overlaps = false;
              if (resStart && resEnd) {
                overlaps =
                  resStart <= filterEndDate && resEnd >= filterStartDate;
              } else if (resStart && !resEnd) {
                // Reservation from resStart onward
                overlaps = resStart <= filterEndDate;
              } else if (!resStart && resEnd) {
                // Reservation until resEnd
                overlaps = resEnd >= filterStartDate;
              }
              dateMatch = !overlaps;
            }
          }
        }
        return (
          manufacturerMatch &&
          companyMatch &&
          statusMatch &&
          ownerMatch &&
          locationMatch &&
          activeMatch &&
          motorisationMatch &&
          dateMatch
        );
      });
      state.vehicleSearchList = filtered;
    },

    sortingAtoZ: (state, action) => {
      state.vehicleSearchList?.sort((a, b) =>
        a?.[action.payload]?.localeCompare(b?.[action.payload])
      );
    },

    sortingZtoA: (state, action) => {
      state.vehicleSearchList?.sort((a, b) =>
        b?.[action.payload]?.localeCompare(a?.[action.payload])
      );
    },

    setSingleParamsData: (state, action) => {
      state.singleParamsData = action.payload;
    },
  },
});

export const {
  getModalDropdown,
  getModalALLValues,
  getManufacturerDropdown,
  getFuleDropdown,
  getVehicleList,
  searchVehicleData,
  getSingleVehicleData,
  getSingleVehicleDocument,
  sortingAtoZ,
  sortingZtoA,
  getSingleVisibiliteData,
  changeSearchText,
  setFleetCurrentPage,
  loader,
  setSingleParamsData,
} = vehicleSlice.actions;
export default vehicleSlice.reducer;

// Api call

// Manufacturer Start
export const fetchManufacturerDropdown = () => async (dispatch) => {
  try {
    const tempData = await getManufacturerDropdownValue();
    dispatch(getManufacturerDropdown(tempData?.data));
  } catch (error) {
    console.log(
      "🚀 ~ file: vehicleSlice.js:176 ~ fetchManufacturerDropdown ~ error:",
      error
    );
  }
};

// Modal Start
export const fetchModalDropdown = (id) => async (dispatch) => {
  try {
    const tempData = await getModalDropdownValue(id);
    dispatch(getModalDropdown(tempData?.data));
  } catch (error) {
    console.log(
      "🚀 ~ file: vehicleSlice.js:186 ~ fetchModalDropdown ~ error:",
      error
    );
  }
};
export const fetchModalAllValue = (id) => async (dispatch) => {
  try {
    const tempData = await getModalALLDropdownValue(id);
    dispatch(getModalALLValues(tempData?.data));
  } catch (error) {
    console.log(
      "🚀 ~ file: vehicleSlice.js:194 ~ fetchModalAllValue ~ error:",
      error
    );
  }
};

// FuelDropdown start
export const fetchFuelDropdown = () => async (dispatch) => {
  try {
    const tempData = await getFuleDropdownValue();
    dispatch(getFuleDropdown(tempData?.data));
  } catch (error) {
    console.log(
      "🚀 ~ file: vehicleSlice.js:204 ~ fetchFuelDropdown ~ error:",
      error
    );
  }
};

// Vehicle List
export const fetchVehicleList = () => async (dispatch) => {
  try {
    dispatch(loader(true));
    const tempData = await getVehicle();
    dispatch(getVehicleList(tempData?.data));
    dispatch(loader(false));
  } catch (error) {
    console.log(
      "🚀 ~ file: vehicleSlice.js:216 ~ fetchVehicleList ~ error:",
      error
    );
  }
};
// Single Vehicle Data
export const fetchSingleVehicleList = (id) => async (dispatch) => {
  console.log(
    "🚀 ~ file: vehicleSlice.js:237 ~ fetchSingleVehicleList ~ id:",
    id
  );
  try {
    dispatch(loader(true));
    const tempData = await getVehicleById(id);
    console.log(
      "🚀 ~ file: vehicleSlice.js:241 ~ fetchSingleVehicleList ~ tempData:",
      tempData
    );
    const tempDocumentData = await getDocumentById(id);
    dispatch(getSingleVehicleData(tempData?.data));
    dispatch(getSingleVehicleDocument(tempDocumentData?.data));
  } catch (error) {
    console.log(
      "🚀 ~ file: vehicleSlice.js:228 ~ fetchSingleVehicleList ~ error:",
      error
    );
  }
};
// Single Vehicle Data
export const fetchSingleVisibilite = (id) => async (dispatch) => {
  try {
    const tempData = await singleVisibiliteInfo(id);
    dispatch(getSingleVisibiliteData(tempData?.data));
  } catch (error) {
    console.log(
      "🚀 ~ file: vehicleSlice.js:237 ~ fetchSingleVisibilite ~ error:",
      error
    );
  }
};
